import { signal } from "@preact/signals";
import { fetchSystemConfig } from "services/backend/system";

type SystemConfig = {
    enableSignup: boolean;
    enableInvitedSignup: boolean;
}

export const globalSystemConfig = signal<SystemConfig>({
    enableSignup: false,
    enableInvitedSignup: true
});

export async function initializeSystemConfig() {
    console.log("fetching system config")
    const result = await fetchSystemConfig();
    if (result.data?.systemConfig) {
        globalSystemConfig.value = {
            ...globalSystemConfig!.value ?? {},
            enableInvitedSignup: result.data.systemConfig.enableInvitedSignup,
            enableSignup: result.data.systemConfig.enableSignup
        };
    }
    //globalSystemConfig.value!.enableSignup = true;
}
